import React from "react";

export default function PageHero({ eyebrow, title, lead, image, alt }) {
  return (
    <section className="bg-[var(--tb-surface)] border-b border-[var(--tb-border)]">
      <div className="container-page section-spacing grid gap-10 lg:grid-cols-12 items-center">
        <div className="lg:col-span-7 fade-up">
          {eyebrow && (
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-[var(--tb-primary)] mb-4">
              {eyebrow}
            </span>
          )}
          <h1 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[var(--tb-text)] text-balance">
            {title}
          </h1>
          {lead && (
            <p className="mt-5 md:mt-6 text-lg md:text-xl text-[var(--tb-text-2)] max-w-2xl text-pretty">
              {lead}
            </p>
          )}
        </div>
        {image && (
          <div className="lg:col-span-5 fade-up">
            <div className="relative aspect-[4/3] rounded-3xl overflow-hidden border border-[var(--tb-border)] shadow-sm">
              <img src={image} alt={alt || ""} className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
